import React from "react";
import { Spinner } from "@fluentui/react-components";
import { loading, loadingSkeleton } from "./OwaHeaderAppLauncherContent.scss";

export default function OwaHeaderAppLauncherLoading(): React.JSX.Element {
    return (<div className={loading}>
            <div className={loadingSkeleton}>
                <Spinner size="medium"/>
            </div>
        </div>);
}
